// material-ui
import { Typography } from '@mui/material';
import { useState, useEffect, useContext } from 'react';
// project imports
import NavGroup from './NavGroup';
import axiosInstance from 'interceptors/axiosInstance';
import { menuAPI } from 'api/api';
import home from 'menu-items/Home';
import config from 'menu-items/Config';
import logout from 'menu-items/logout';
import { AppContext } from 'App';
import { IconKey } from '@tabler/icons-react';
import { UserContext } from 'layout/MainLayout';

// constant
const icons = { IconKey };

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const [menus, setMenus] = useState({
    Key: 'client',
    Type: 'group',
    Items: [
      {
        Key: 'active',
        ParentKey: 'active',
        Type: 'collapse',
        Text: 'Active',
        icon: icons.IconKey,
        Items: []
      },
      {
        Key: 'archive',
        ParentKey: 'archive',
        Type: 'collapse',
        Text: 'Archived',
        icon: icons.IconKey,
        Items: []
      }
    ]
  });

  const user = useContext(UserContext);

  let menuItem = {};
  if (user.UserRole === 'Admin') {
    menuItem = {
      items: [home, menus, config, logout]
    };
  } else {
    menuItem = {
      items: [home, menus, logout]
    };
  }

  // Consumer of AppContext API
  const { menuValue } = useContext(AppContext);
  const [refreshMenus] = menuValue;

  useEffect(() => {
    // console.log(refreshMenus);
    const fetchMenu = async () => {
      await axiosInstance
        .get(menuAPI)
        .then((response) => {
          const activeOpportinity = response.data
            .filter((oppo) => parseInt(oppo.IsActive) === 1 || oppo.IsActive === null) // Filter outer scope
            .map((oppo) => ({
              ...oppo,
              Items: oppo.Items ? oppo.Items.filter((item) => parseInt(item.IsActive) === 1) : [] // Filter inner Items
            }));

          const archiveOpportinity = response.data
            .filter((oppo) => parseInt(oppo.IsActive) === 0 || oppo.IsActive === null) // Filter outer scope
            .map((oppo) => ({
              ...oppo,
              Items: oppo.Items ? oppo.Items.filter((item) => parseInt(item.IsActive) === 0) : [] // Filter inner Items
            }));

          setMenus({
            ...menus,
            Items: [
              { ...menus.Items[0], Items: activeOpportinity },
              { ...menus.Items[1], Items: archiveOpportinity }
            ]
          });
        })
        .catch((error) => console.log(error));
    };
    fetchMenu();
  }, [refreshMenus]);

  const navItems = menuItem.items.map((item) => {
    switch (item.Type) {
      case 'group':
        return <NavGroup key={item.Key} item={item} />;
      default:
        return (
          <Typography key={item.Key} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;
